// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"da0f203f","82":"16fa57f6","208":"5a8626f8","400":"6252f84d","488":"996c6a8c","572":"ed6bc157","671":"d45ef426","815":"d286b40b","885":"3c760a5c","925":"83c1e938"}[chunkId] + ".chunk.js";
};